import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaRestosPagar: ['administracao'],
    setExercicioInicialConsultaRestosPagar: ['exercicioInicial'],
    setExercicioFinalConsultaRestosPagar: ['exercicioFinal'],
    setNumeroEmpenhoInicialConsultaRestosPagar: ['numeroEmpenhoInicial'],
    setNumeroEmpenhoFinalConsultaRestosPagar: ['numeroEmpenhoFinal'],
    setDataEmpenhoInicialConsultaRestosPagar: ['dataEmpenhoInicial'],
    setDataEmpenhoFinalConsultaRestosPagar: ['dataEmpenhoFinal'],
    setDataVencimentoInicialConsultaRestosPagar: ['dataVencimentoInicial'],
    setDataVencimentoFinalConsultaRestosPagar: ['dataVencimentoFinal'],
    setRecursoConsultaRestosPagar: ['recurso'],
    setDestinacaoConsultaRestosPagar: ['destinacao'],
    limpaFiltroConsultaRestosPagar: [],
    receberFiltroConsultaRestosPagar: ['filtroRecebido'],
    setStatusConsultaRestosPagar: ['status'],
})

const INITIAL_STATE = {
    administracao: [],
    exercicioInicial: new Date().getFullYear(),
    exercicioFinal: '',
    numeroEmpenhoInicial: '',
    numeroEmpenhoFinal: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    recurso: [],
    destinacao: [],
    status: { label: '', value: '' },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setExercicioInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioInicial: action.exercicioInicial }
}
const setExercicioFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioFinal: action.exercicioFinal }
}
const setNumeroEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoInicial: action.numeroEmpenhoInicial }
}
const setNumeroEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoFinal: action.numeroEmpenhoFinal }
}
const setDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: action.dataEmpenhoInicial }
}
const setDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: action.dataEmpenhoFinal }
}
const setDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: action.dataVencimentoInicial }
}
const setDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: action.dataVencimentoFinal }
}
const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}

const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_RESTOS_PAGAR]: setAdministracao,
    [Types.SET_EXERCICIO_INICIAL_CONSULTA_RESTOS_PAGAR]: setExercicioInicial,
    [Types.SET_EXERCICIO_FINAL_CONSULTA_RESTOS_PAGAR]: setExercicioFinal,
    [Types.SET_NUMERO_EMPENHO_INICIAL_CONSULTA_RESTOS_PAGAR]: setNumeroEmpenhoInicial,
    [Types.SET_NUMERO_EMPENHO_FINAL_CONSULTA_RESTOS_PAGAR]: setNumeroEmpenhoFinal,
    [Types.SET_DATA_EMPENHO_INICIAL_CONSULTA_RESTOS_PAGAR]: setDataEmpenhoInicial,
    [Types.SET_DATA_EMPENHO_FINAL_CONSULTA_RESTOS_PAGAR]: setDataEmpenhoFinal,
    [Types.SET_DATA_VENCIMENTO_INICIAL_CONSULTA_RESTOS_PAGAR]: setDataVencimentoInicial,
    [Types.SET_DATA_VENCIMENTO_FINAL_CONSULTA_RESTOS_PAGAR]: setDataVencimentoFinal,
    [Types.SET_RECURSO_CONSULTA_RESTOS_PAGAR]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_RESTOS_PAGAR]: setDestinacao,
    [Types.LIMPA_FILTRO_CONSULTA_RESTOS_PAGAR]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_RESTOS_PAGAR]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_RESTOS_PAGAR]: setStatus,
})
